__turbopack_context__.v({
  "ai-label": "ai-label-module__wR8gLG__ai-label",
});
